import { StorageSerializers, useSessionStorage } from '@vueuse/core'

const TTL = 10 * 60000

export const useCacheStorage = () => {
  const now = Date.now()

  const getCache = async (key: string) => {
    const storage = useSessionStorage(
      key,
      { ttl: now, data: null },
      {
        serializer: StorageSerializers.object
      }
    )

    if (storage.value.ttl + TTL < now) {
      storage.value.data = null
      storage.value.ttl = now
    }

    return storage
  }

  return { getCache }
}
